import React, { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import {
  getFinanceEmbeddedNotepadNotes,
  patchFinanceEmbeddedNotepadNotes,
} from '../../viewServices/assets_api';
import { formatApiError } from '../../viewServices/snapshot_form_shared';
import EmbeddedNotepadSlotsPanel from 'shared_items/embeddedNotepad/EmbeddedNotepadSlotsPanel';
import {
  FINANCE_DEFAULT_EMBEDDED_NOTEPAD_LINKS,
  FINANCE_EMBEDDED_NOTEPAD_SLOTS,
} from '../../viewServices/embeddedNotepadFinanceConfig';

const TemporaryInfoPanel = () => {
  const fetchLinks = useCallback(async () => {
    const res = await getFinanceEmbeddedNotepadNotes();
    return res.data;
  }, []);

  const patchLinks = useCallback(async (partial) => {
    const res = await patchFinanceEmbeddedNotepadNotes(partial);
    return res.data;
  }, []);

  const onLoadError = useCallback((err) => {
    toast.error(formatApiError(err.response?.data) || err.message || 'Failed to load linked notes');
  }, []);

  const onLinkError = useCallback((err) => {
    toast.error(formatApiError(err.response?.data) || err.message || 'Failed to link note');
  }, []);

  return (
    <EmbeddedNotepadSlotsPanel
      slots={FINANCE_EMBEDDED_NOTEPAD_SLOTS}
      defaultLinks={FINANCE_DEFAULT_EMBEDDED_NOTEPAD_LINKS}
      fetchLinks={fetchLinks}
      patchLinks={patchLinks}
      onLoadError={onLoadError}
      onLinkError={onLinkError}
    />
  );
};

export default TemporaryInfoPanel;
